<div>
    <h1>{{ title }}</h1>
    <div style="overflow-x: auto; min-width: 0; width: 100%;">
        <p-table #dt1 dataKey="id" [value]="pagedItems()" [lazy]="true" [columns]="selectedColumns"
          (onLazyLoad)="loadItems($event)" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]"
          [loading]="loading()" showGridlines stripedRows size="small"
          selectionMode="single" [(selection)]="selectedItems"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [paginator]="true"
          [rows]="pageable.size" [totalRecords]="totalElements()" [globalFilterFields]="filterFields"
          [resizableColumns]="true" columnResizeMode="fit" sortMode="multiple" responsiveLayout="stack" [tableStyle]="{'min-width': '100%'}">
          <ng-template #caption>
            <div class="flex flex-row flex-wrap">
              <p-button-group class="w-2">
                <p-button pRipple icon="fas fa-file-csv" (click)="dt1.exportCSV()" pTooltip="Save as CSV"
                  tooltipPosition="bottom"/>
                <p-button pRipple icon="fas fa-file-excel" (click)="exportExcel()"
                  severity="success" pTooltip="Save as XLS" tooltipPosition="bottom"/>
                <p-button pRipple icon="fa-solid fa-arrows-rotate" (click)="refresh()"
                  severity="info" pTooltip="Refresh" tooltipPosition="bottom"/>  
              </p-button-group>
              <p-inputgroup class="w-10">
                <p-inputGroupAddon>
                  <i class="fas fa-search"></i>
                </p-inputGroupAddon>
                <input pInputText type="text" (input)="dt1.filterGlobal($event, 'contains')" placeholder="Search" />
                <p-multiSelect [options]="columns" [(ngModel)]="selectedColumns" optionLabel="header"
                  selectedItemsLabel="{0} columns selected" ngClass="pl-2 flex grow"
                placeholder="Choose Columns"></p-multiSelect>
              </p-inputgroup>
            </div>
          </ng-template>
          <!-- <ng-template pTemplate=""> -->
          <!-- <div class="p-d-flex">
          <button
            type="button"
            pButton
            pRipple
            icon="fas fa-file-csv"
            (click)="dt1.exportCSV()"
            class="p-mr-2"
            pTooltip="CSV"
            tooltipPosition="bottom"
          ></button>
          <button
            type="button"
            pButton
            pRipple
            icon="fas fa-file-excel"
            (click)="exportExcel()"
            class="p-button-success p-mr-2"
            pTooltip="XLS"
            tooltipPosition="bottom"
          ></button>
          <!--      <button
          type="button"
          pButton
          pRipple
          icon="fas fa-file-csv"
          (click)="dt1.exportCSV({ selectionOnly: true })"
          class="p-button-info p-ml-auto"
          pTooltip="Selection Only"
          tooltipPosition="bottom"
        ></button>-->

      <!-- </div>
    </ng-template> -->

    <ng-template #header>
      <tr>
        <th style="width: 3rem">
          <!--<p-tableHeaderCheckbox></p-tableHeaderCheckbox>-->
          Row
        </th>

        @for (column of selectedColumns; track column) {
          <th pResizableColumn [pSortableColumn]="column.field">
            <div class="flex justify-content-between align-items-center">
              {{ column.header }} <p-sortIcon [field]="column.field"></p-sortIcon>
            </div>
          </th>
        }
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <!--<tr class="p-selectable-row">-->
      <tr>
        <td style="width: 3rem">
          {{ rowIndex + 1 }}
          <!--<p-tableCheckbox [value]="rowData"></p-tableCheckbox>-->
        </td>

      @for (col of selectedColumns; track col) {
        <td><span class="p-column-title">{{ col.header }}</span>
          @if (col.filterType === 'object') {
            <div>
              {{ col.content(rowData[col.field]) | json | ellipsis: 50 }}
            </div>
          }
          @if (col.filterType === 'numeric') {
            <div>
              {{ col.content(rowData[col.field]) }}
            </div>
          }
          @if (col.filterType === 'date') {
            <div>
              {{ col.content(rowData[col.field]) | date: "short" }}
            </div>
          }
          @if (col.filterType === 'text') {
            <div>
              {{ col.content(rowData[col.field]) | ellipsis: 50 }}
            </div>
          }
        </td>
      }
      <td>
        <button pButton icon="fas fa-edit" class="p-button p-button-primary mr-2" (click)="edit(rowData)"></button>
        <button pButton icon="fas fa-times" class="p-button p-button-danger mr-2"
        (click)="delete(rowData)"></button>
        <button pButton icon="fas fa-check" class="p-button p-button-success" (click)="onClick(rowData)"></button>
      </td>
    </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="columns.length + 2">No Items found.</td>
      </tr>
    </ng-template>
    </p-table>
  </div>
</div>